import { LEGAL_INFO } from './legal-info';
import { LegalLayout } from './LegalLayout';

export function CguPage() {
  return (
    <LegalLayout
      title="Conditions Générales d'Utilisation"
      subtitle={`Règles d'utilisation du service « ${LEGAL_INFO.productName} ».`}
    >
      <section>
        <h2>1. Objet</h2>
        <p>
          Les présentes Conditions Générales d'Utilisation (« <strong>CGU</strong> ») définissent
          les règles d'utilisation du service « {LEGAL_INFO.productName} » (« le Service »), édité
          par {LEGAL_INFO.companyName}. Elles s'appliquent à tout utilisateur du Service, y compris
          les utilisateurs des Clients souscripteurs d'un abonnement.
        </p>
        <p>
          La relation commerciale entre {LEGAL_INFO.companyName} et le Client souscripteur est régie
          par les <a href="/legal/cgv">Conditions Générales de Vente</a>.
        </p>
      </section>

      <section>
        <h2>2. Acceptation des CGU</h2>
        <p>
          L'utilisation du Service vaut acceptation pleine et entière des présentes CGU. Tout
          utilisateur qui n'accepte pas tout ou partie de ces CGU doit renoncer à utiliser le
          Service.
        </p>
      </section>

      <section>
        <h2>3. Accès au Service</h2>
        <h3>3.1 Conditions d'accès</h3>
        <p>
          L'accès au Service est réservé aux utilisateurs disposant d'un compte valide, créé par
          l'administrateur de leur organisation cliente ou par {LEGAL_INFO.companyName} (sur
          invitation par e-mail). Le Service est destiné à un usage professionnel.
        </p>
        <h3>3.2 Identifiants</h3>
        <p>
          L'utilisateur choisit un mot de passe d'une longueur minimale de douze (12) caractères et
          active obligatoirement, le cas échéant, l'authentification à deux facteurs (TOTP) si
          celle-ci lui est demandée. Il s'engage à préserver la confidentialité de ses identifiants
          et à informer sans délai l'administrateur de son organisation et/ou{' '}
          {LEGAL_INFO.companyName} en cas de soupçon de compromission.
        </p>
        <p>
          Toute action effectuée à partir d'un compte utilisateur est réputée provenir de son
          titulaire.
        </p>
      </section>

      <section>
        <h2>4. Disponibilité</h2>
        <p>
          {LEGAL_INFO.companyName} met en œuvre les moyens techniques raisonnables pour assurer la
          disponibilité du Service vingt-quatre heures sur vingt-quatre, sept jours sur sept.
          Toutefois, l'accès peut être interrompu pour des opérations de maintenance, mises à jour,
          ou en raison de cas de force majeure. {LEGAL_INFO.companyName} s'efforce d'en minimiser
          l'impact et d'informer les utilisateurs lorsque cela est possible.
        </p>
      </section>

      <section>
        <h2>5. Usage du Service</h2>
        <h3>5.1 Usages autorisés</h3>
        <p>
          L'utilisateur s'engage à utiliser le Service conformément à sa destination, dans le
          respect des lois et règlements en vigueur, et des règles de l'art en matière de sécurité
          informatique.
        </p>
        <h3>5.2 Usages prohibés</h3>
        <p>L'utilisateur s'interdit notamment de :</p>
        <ul>
          <li>
            utiliser le Service à des fins illicites, frauduleuses ou portant atteinte aux droits de
            tiers ;
          </li>
          <li>tenter d'accéder à des comptes, organisations ou données ne lui appartenant pas ;</li>
          <li>
            contourner les mesures de sécurité du Service, en analyser le code, le décompiler ou
            tenter d'en exploiter des vulnérabilités à d'autres fins que la notification responsable
            à l'éditeur ;
          </li>
          <li>
            réaliser des tests de charge, scans automatisés ou « scrapping » massif sans accord
            écrit préalable de {LEGAL_INFO.companyName} ;
          </li>
          <li>
            téléverser des contenus illicites, contrefaits, diffamatoires, à caractère
            discriminatoire, ou portant atteinte à la vie privée de tiers ;
          </li>
          <li>
            utiliser le Service pour envoyer des communications non sollicitées (spam) ou véhiculer
            des programmes malveillants ;
          </li>
          <li>
            revendre, sous-louer ou mettre à disposition de tiers son accès au Service sans
            autorisation expresse.
          </li>
        </ul>
        <h3>5.3 Conformité RGPD</h3>
        <p>
          L'utilisateur s'engage à ne pas téléverser de données à caractère personnel pour
          lesquelles il ne disposerait pas d'une base légale conformément au RGPD, et à respecter le
          principe de minimisation des données dans les automatisations qu'il configure.
        </p>
      </section>

      <section>
        <h2>6. Suspension et résiliation</h2>
        <p>
          En cas de manquement aux présentes CGU, et notamment d'usage prohibé visé à l'article 5.2,{' '}
          {LEGAL_INFO.companyName} se réserve le droit, sans préavis ni indemnité, de suspendre
          l'accès au compte concerné, voire de le supprimer en cas de manquement grave ou répété.{' '}
          {LEGAL_INFO.companyName} en informe l'administrateur de l'organisation cliente.
        </p>
      </section>

      <section>
        <h2>7. Données personnelles</h2>
        <p>
          Le traitement des données à caractère personnel collectées via le Service est décrit dans
          la <a href="/legal/confidentialite">Politique de confidentialité</a>. Pour exercer ses
          droits, l'utilisateur peut écrire à{' '}
          <a href={`mailto:${LEGAL_INFO.dpoEmail}`}>{LEGAL_INFO.dpoEmail}</a>.
        </p>
      </section>

      <section>
        <h2>8. Propriété intellectuelle</h2>
        <p>
          Les éléments du Service (logiciel, interface, contenus éditoriaux, marques) appartiennent
          à {LEGAL_INFO.companyName} ou à ses concédants. L'utilisateur bénéficie d'un droit d'usage
          personnel et non transférable, limité à la durée de l'abonnement souscrit par son
          organisation et au périmètre fonctionnel de cet abonnement.
        </p>
        <p>
          Les données et contenus que l'utilisateur ou son organisation transmettent via le Service
          demeurent leur propriété exclusive.
        </p>
      </section>

      <section>
        <h2>9. Responsabilité de l'utilisateur</h2>
        <p>
          L'utilisateur est seul responsable de l'usage qu'il fait du Service et des contenus qu'il
          y publie ou y traite. Il garantit {LEGAL_INFO.companyName} contre toute réclamation,
          action ou condamnation résultant d'un manquement aux présentes CGU.
        </p>
      </section>

      <section>
        <h2>10. Évolution du Service et des CGU</h2>
        <p>
          {LEGAL_INFO.companyName} se réserve la faculté de faire évoluer le Service et les
          présentes CGU. Les évolutions des CGU sont notifiées avec un préavis raisonnable et
          opposables à compter de leur entrée en vigueur. L'utilisateur qui poursuit l'utilisation
          du Service après cette date est réputé les avoir acceptées.
        </p>
      </section>

      <section>
        <h2>11. Droit applicable</h2>
        <p>
          Les présentes CGU sont régies par le droit français. Tout litige relatif à leur
          interprétation ou à leur exécution est, à défaut d'accord amiable, soumis à la compétence
          des tribunaux français.
        </p>
      </section>
    </LegalLayout>
  );
}
